$(document).ready(function () {
  $('[href="#"]').attr("href", "javascript:;");

  $(".index-slider").slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    autoplay:true,
    autoplaySpeed:7500,
    pauseOnFocus:false,
    pauseOnHover:false,
    fade:true,
    slidesToShow: 1,
    slidesToScroll: 1,
        prevArrow:
      "<button class='hiw-btn hiw-btn-left'><i class='fa fa-chevron-left'></i></button>",
    nextArrow:
      "<button class='hiw-btn hiw-btn-right'><i class='fa fa-chevron-right'></i></button>",
  });

  $('.product-det-slider').slick({
  dots: true,
  arrows:true,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow:
      "<button class='flash-sale-slider-btn fssb-btn-left'><i class='fa fa-chevron-left'></i></button>",
    nextArrow:
      "<button class='flash-sale-slider-btn fssb-btn-right'><i class='fa fa-chevron-right'></i></button>",
    
});
  


  // Tabbing JS
$('[data-targetit]').on('click', function(e) {
  $(this).addClass('current');
  $(this).siblings().removeClass('current');
  var target = $(this).data('targetit');
  $('.' + target).siblings('[class^="boxTabs-"]').hide();
  $('.' + target).fadeIn();
  $(".tab-slider").slick("setPosition");
});


});

$('.townslider').slick({
  dots: false,
  arrows:false,
  infinite: true,
  autoplay:true,
  cssEase: 'linear',
  speed: 5000,
  // centerMode: true,
  variableWidth: true,
  slidesToShow: 1,
  slidesToScroll: 1,
});

if ($(window).width() > 767) {
$(window).scroll(function() {
    var scroll = $(window).scrollTop();
    if (scroll >= 770) {
        $(".fixed").addClass("sticky");
    } else {
        $(".fixed").removeClass("sticky");
    }
});

  
}


if ($(window).width() < 767) {

//   $(window).scroll(function() {
//     var scroll = $(window).scrollTop();
//     if (scroll >= 450) {
//         $(".fixed").addClass("sticky");
//     } else {
//         $(".fixed").removeClass("sticky");
//     }
// });
  
   $('.cat-sec ul').slick({
  dots: true,
  arrows:false,
  infinite: false,
  speed: 300,
     edgeFriction:0,
  slidesToShow: 2.5,
  slidesToScroll: 1,
});

   $('.freskbasket-bundles-section .row').slick({
  dots: true,
  arrows:false,
  infinite: false,
  speed: 500,
     autoplay:true,
  slidesToShow: 1,
  slidesToScroll: 1,
     adaptiveHeight:true,
});






//MOBILE Header/Mobile Bar Facebook like
// Select the elements we want to hide/show
const header = document.querySelector('#section-header-3');
const stickyBar = document.querySelector('.mobile-stickybar-rad');

let lastScrollY = window.pageYOffset;
let ticking = false;

function updateHeader() {
  const currentScrollY = window.pageYOffset;

  
if (currentScrollY === 0) {
    // At the top of the page
    header.style.transform = 'translateY(0)';
    stickyBar.style.transform = 'translateY(0)';
    header.classList.add('header-sticky-activated');
  } else if (currentScrollY > lastScrollY) {
    // Scrolling down
    header.style.transform = 'translateY(-120%)';
    stickyBar.style.transform = 'translateY(120%)';
    header.classList.remove('header-sticky-activated');
  } else {
    // Scrolling up
    header.style.transform = 'translateY(0)';
    stickyBar.style.transform = 'translateY(0)';
        header.classList.add('header-sticky-activated');
  }

  lastScrollY = currentScrollY;
  ticking = false;
}

function onScroll() {
  if (!ticking) {
    window.requestAnimationFrame(updateHeader);
    ticking = true;
  }
}

  // Initial call to set correct state on page load
updateHeader();

// Add smooth transition
header.style.transition = 'transform 0.3s ease-in-out';
stickyBar.style.transition = 'transform 0.3s ease-in-out';

// Listen for scroll events
window.addEventListener('scroll', onScroll, { passive: true });


  
  
}

$('.change-deliver-navbar-btn').on("click",function(){

  $('.change-deliver-modal').fadeIn();

})
$('.close-cdm').on("click",function(){

  $('.change-deliver-modal').fadeOut();

})

$('.cdmw-btn').on("click",function(){


  console.log("value :" ,$('.cdmw-select').val())

  

  let location = $('.cdmw-select').val();
if(location==='khi'){

  $('.change-deliver-modal').fadeOut();

}else if(location==='nw'){

  window.location.assign('https://9c79b4.myshopify.com/')
}

  
  
})
